import { gql } from "@apollo/client";export default gql`mutation AddBlockTagMap($objects: [worksheet_block_tag_map_insert_input!]!) {
    addBlockTagMap: insert_worksheet_block_tag_map(objects: $objects) {
        affected_rows
    }
}
`;
